__turbopack_context__.v({
  "container": "bzRkta_container",
  "isSelected": "bzRkta_isSelected",
  "label": "bzRkta_label",
  "list": "bzRkta_list",
  "listButton": "bzRkta_listButton",
  "variant--bottom": "bzRkta_variant--bottom",
});
